import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Cart, Close, Menu, Search } from "./icons";
import { readableColor, rem } from "polished";
import { Badge } from "./Badge";
import { SearchFieldFullWidth } from "./SearchFieldFullWidth";
import { bestReadableColor } from "./utils";
import styled from "@emotion/styled";
import { useState } from "react";
import { colors } from "../theme";
import { Tooltip } from "./Tooltip";
import { Trans } from "@lingui/react";
export function RTCHeaderMobile({ backgroundColor, bannerActive, bannerBackgroundColor, bannerContent, bannerTypography, bannerVisibility, containerSize, disabledCart, homeUrl, isInHome, itemsCount, logoColor, logoContent, logoImage, logoType, logoTypography, menu, menuTypography, onCartIconClick, onSearch, renderLink, searchPlaceholder, skin, sticky, textColor, }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const logoImageParse = logoImage != null && logoImage !== ""
        ? JSON.parse(logoImage)
        : undefined;
    const showBanner = bannerActive &&
        ((bannerVisibility === "H" && isInHome) || bannerVisibility === "A");
    return (_jsxs(Header, Object.assign({ backgroundColor: backgroundColor, sticky: sticky }, { children: [showBanner && (_jsx(Banner, { dangerouslySetInnerHTML: { __html: bannerContent }, typography: bannerTypography, backgroundColor: bannerBackgroundColor }, void 0)),
            _jsxs(Container, Object.assign({ backgroundColor: backgroundColor, skin: skin }, { children: [_jsx(MenuButton, Object.assign({ onClick: () => setMenuOpen(o => !o), color: readableColor(backgroundColor) }, { children: menuOpen ? _jsx(Close, {}, void 0) : _jsx(Menu, {}, void 0) }), void 0),
                    _jsx(ContainerNavigation, Object.assign({ open: menuOpen }, { children: _jsx(Navigation, Object.assign({ backgroundColor: backgroundColor, containerWidth: containerSize.width }, { children: menu.map(({ id, title, href, type }) => (_jsx(LinkContainer, Object.assign({ skin: skin }, { children: _jsx(Link, Object.assign({ textColor: bestReadableColor(textColor, backgroundColor), typography: menuTypography, onClick: () => setMenuOpen(o => !o) }, { children: type === "L" || renderLink == null ? (_jsx("a", Object.assign({ title: title, href: href }, (type === "L"
                                        ? { rel: "noopener noreferrer", target: "_blank" }
                                        : {}), { children: title }), void 0)) : (renderLink({ title, href })) }), void 0) }), id))) }), void 0) }), void 0),
                    logoType === "T" && (_jsx(Logo, Object.assign({ typography: logoTypography, color: logoColor }, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: logoContent }), void 0) }), void 0)),
                    logoType === "I" && (_jsx(LogoImage, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: _jsx("img", { src: logoImageParse === null || logoImageParse === void 0 ? void 0 : logoImageParse.medium, alt: "Logo de tu marca" }, void 0) }), void 0) }, void 0)),
                    _jsx(SearchButton, Object.assign({ onClick: () => setSearchOpen(o => !o), color: readableColor(backgroundColor) }, { children: _jsx(Search, {}, void 0) }), void 0),
                    _jsx(Tooltip, Object.assign({ content: _jsx(Trans, { id: "No pod\u00E9s agregar productos al carrito en este momento" }, void 0), placement: "bottom-end", maxWidth: 200, disabled: !disabledCart }, { children: _jsx(CartButtonWrapper, { children: _jsx(CartButton, Object.assign({ onClick: onCartIconClick, color: readableColor(backgroundColor), disabled: disabledCart, disabledCart: disabledCart, skin: skin }, { children: itemsCount >= 1 ? (_jsx(Badge, Object.assign({ badgeContent: itemsCount, disabledCart: disabledCart }, { children: _jsx(Cart, {}, void 0) }), void 0)) : (_jsx(Cart, {}, void 0)) }), void 0) }, void 0) }), void 0)] }), void 0),
            _jsx(SearchFieldFullWidth, { arrow: skin === "4" ? "left" : "right", open: searchOpen, placeholder: searchPlaceholder, onSearch: onSearch }, void 0)] }), void 0));
}
const Header = styled.header(({ backgroundColor, sticky }) => (Object.assign({ backgroundColor, border: "none", boxShadow: "0 2px 4px hsla(0, 0%, 0%, 0.15)", display: "flex", flexDirection: "column", height: "auto", position: sticky ? "sticky" : "relative", width: "100%" }, (sticky
    ? {
        top: 0,
        zIndex: 9999,
    }
    : {}))));
const Banner = styled.div(({ backgroundColor, typography }) => ({
    alignItems: "center",
    backgroundColor,
    color: readableColor(backgroundColor),
    display: "flex",
    fontFamily: typography,
    fontSize: "1.2rem",
    justifyContent: "center",
    minHeight: "3rem",
    textAlign: "center",
    padding: "1.2rem",
    "& p": {
        margin: 0,
        fontFamily: typography,
    },
}));
const Container = styled.div(({ backgroundColor, skin }) => ({
    display: "grid",
    gridTemplateAreas: skin === "1" ? "'menu . search cart'" : "'menu search cart'",
    gridTemplateColumns: skin === "1" ? "4rem auto 4rem 4rem" : "4rem 4rem auto",
    gridTemplateRows: "4rem",
    height: "4.8rem",
    padding: skin === "1" ? "0.4rem" : "0.4rem 1.6rem 0.4rem 0.4rem",
    position: "relative",
    "& svg": {
        fontSize: "1.8rem",
    },
}));
const IconButton = styled.button(({ color, disabledCart }) => ({
    alignItems: "center",
    background: "transparent",
    border: "none",
    display: "flex",
    justifyContent: "center",
    margin: "0",
    padding: "0",
    zIndex: 1,
    "& svg": {
        color: disabledCart ? colors.greyMain : color,
        fontSize: "2rem",
    },
}));
const MenuButton = styled(IconButton)(() => ({
    gridArea: "menu",
}));
const Logo = styled.div(({ typography, color }) => ({
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    margin: "0 25%",
    maxHeight: "6rem",
    overflow: "hidden",
    position: "absolute",
    width: "50%",
    wordBreak: "break-word",
    "& a": {
        color,
        fontFamily: typography,
        fontSize: "2.4rem",
        textDecoration: "none",
    },
}));
const Navigation = styled.nav(({ backgroundColor, containerWidth }) => ({
    alignContent: "start",
    backgroundColor,
    display: "grid",
    height: "100%",
    padding: "1.2rem",
    width: rem(containerWidth, 10),
}));
const ContainerNavigation = styled.div(({ open }) => ({
    transform: open ? "scaleY(1)" : "scaleY(0)",
    transformOrigin: "center top",
    transition: "transform 200ms ease-in-out",
    position: "absolute",
    top: "4.8rem",
    boxShadow: "0 2px 4px hsla(0, 0%, 0%, 0.15)",
    zIndex: 2,
}));
const LinkContainer = styled.div(({ skin }) => ({
    borderBottom: skin === "1" ? "1px solid hsla(0, 0%, 0%, 0.1)" : "",
    "& > a": {
        fontSize: "1.4rem",
    },
    "&:last-of-type": {
        borderBottom: "none",
    },
}));
const Link = styled.span(({ textColor, typography }) => ({
    "& > a": {
        display: "inline-block",
        padding: "1.2rem 0.8rem",
        width: "100%",
        color: textColor,
        fontFamily: typography,
        fontSize: "1.6rem",
        textAlign: "left",
        textDecoration: "none",
    },
}));
const SearchButton = styled(IconButton)(() => ({
    gridArea: "search",
    height: "100%",
    width: "100%",
}));
const CartButtonWrapper = styled.span(() => ({
    alignSelf: "center",
}));
const CartButton = styled(IconButton)(({ skin }) => (Object.assign({ gridArea: "cart" }, (skin === "4"
    ? {
        width: "100%",
        justifyContent: "flex-end",
    }
    : {}))));
const LogoImage = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    maxHeight: "6rem",
    overflow: "hidden",
    position: "absolute",
    width: "100%",
    "& a": {
        height: "100%",
        maxHeight: "3.6rem",
    },
    "& img": {
        height: "100%",
        maxHeight: "3.6rem",
    },
}));
//# sourceMappingURL=RTCHeaderMobile.js.map